import { createTheme } from "@mui/material"
import { grey } from "@mui/material/colors"

export function buildTheme(mode: "light" | "dark") {
    return createTheme({
        palette: {
            mode,
            primary: { main: "#E1523E" },
            secondary: { main: grey[400] },
        },
    })
}
